(() => {
  'use strict';
  const KEY = 'bg:recently-viewed:v1', MAX = 12, TTL = 30 * 24 * 60 * 60 * 1000;
  const validId = id => Number.isSafeInteger(id) && id > 0;
  const identity = item => `${item.productId}:${item.familyId}`;
  function cleanHistory(value, now = Date.now()) {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.filter(item => item && validId(item.productId) && validId(item.familyId) && validId(item.variantId)
      && typeof item.url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/?#]+$/i.test(item.url)
      && Number.isFinite(item.at) && item.at <= now && now - item.at < TTL)
      .sort((a, b) => b.at - a.at).filter(item => {
        const key = identity(item); if (seen.has(key)) return false; seen.add(key); return true;
      }).slice(0, MAX).map(({productId, familyId, variantId, url, at}) => ({productId, familyId, variantId, url, at}));
  }
  function remember(history, item, now = Date.now()) {
    return cleanHistory([{...item, at: now}, ...history.filter(row => identity(row) !== identity(item))], now);
  }
  function previous(history, current) { return history.filter(row => identity(row) !== identity(current)).slice(0, 6); }
  function readHistory(storage) { try { return cleanHistory(JSON.parse(storage.getItem(KEY) || '[]')); } catch { return []; } }
  function saveHistory(storage, history) { try { storage.setItem(KEY, JSON.stringify(history)); } catch { /* Browsing still works with storage disabled. */ } }
  // The history rules are also exercised by the local regression tests.
  if (typeof module !== 'undefined' && module.exports) { module.exports = {cleanHistory, remember, previous, readHistory, saveHistory, TTL}; return; }
  const section = document.getElementById('bg-recently-viewed'), node = document.getElementById('bg-v2-data');
  if (!section || !node) return;
  let data;
  try { data = JSON.parse(node.textContent); } catch { return; }
  if (data.isPackaging || !data.main?.variants?.length) return;
  const main = data.main, familyId = Math.min(...main.variants.map(v => v.id));
  let storage; try { storage = window.localStorage; } catch { /* Use this page's memory only. */ }
  let history = readHistory(storage);
  let current = {productId: main.id, familyId, variantId: main.selected, url: main.url};
  const list = section.querySelector('#bg-recent-items'), controls = section.querySelector('.bg-recent-controls');
  const prev = section.querySelector('[data-recent-prev]'), next = section.querySelector('[data-recent-next]');
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:data.currency}).format(value / 100);
  function record(id) {
    if (!main.variants.some(v => v.id === id)) return;
    current.variantId = id;
    history = remember(history, current);
    saveHistory(storage, history);
  }
  function updateControls() {
    const overflow = list.scrollWidth - list.clientWidth;
    controls.hidden = overflow <= 2;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft >= overflow - 2;
  }
  function scroll(direction) {
    list.scrollBy({left: direction * list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
  prev.addEventListener('click', () => scroll(-1)); next.addEventListener('click', () => scroll(1));
  list.addEventListener('scroll', updateControls, {passive:true});
  new ResizeObserver(updateControls).observe(list);
  async function freshProduct(item) {
    const url = new URL(item.url, location.origin);
    url.searchParams.set('variant', item.variantId); url.searchParams.set('section_id', 'bg-recent-product');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, {credentials:'same-origin', signal:controller.signal});
      if (!response.ok) return null;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-bg-recent-product]'); if (!content) return null;
      const p = JSON.parse(content.textContent), v = p.variants?.find(row => row.id === item.variantId);
      if (p.id !== item.productId || !v || Math.min(...p.variants.map(row => row.id)) !== item.familyId || !v.image) return null;
      return {p, v};
    } catch { return null; } finally { clearTimeout(timeout); }
  }
  function card({p, v}) {
    const media = window.bellaVariantMediaFor?.(v.id, v.image), frame = media?.frame;
    const styles = frame && window.bellaVariantFrameStyles?.(frame);
    const title = p.shortTitle || p.title;
    const label = /^(default title|as shown)$/i.test(v.label) ? '' : v.label;
    return `<li class="bg-card"><a class="rec-link" href="${esc(p.url)}?variant=${v.id}"><div class="rec-image ${frame ? 'has-frame' : ''}"><div class="media-frame" ${styles?.viewport ? `style="${esc(styles.viewport)}"` : ''}><img src="${esc(media?.src || v.image)}" alt="${esc(title)}" loading="lazy" width="400" height="500" ${styles?.image ? `style="${esc(styles.image)}"` : ''}></div></div><span class="bg-card-title">${esc(title)}</span>${label ? `<span class="bg-recent-option">${esc(label)}</span>` : ''}<span class="bg-card-price">${money(v.price)}${v.available ? '' : ' · Sold out'}</span></a></li>`;
  }
  let renderId = 0;
  async function render() {
    const id = ++renderId, items = previous(history, current);
    if (!items.length) { section.hidden = true; list.replaceChildren(); return; }
    const products = (await Promise.all(items.map(freshProduct))).filter(Boolean);
    if (id !== renderId) return;
    list.innerHTML = products.map(card).join(''); section.hidden = !products.length; updateControls();
  }
  record(main.selected); render();
  document.addEventListener('bg:variant-change', event => record(event.detail?.id));
  window.addEventListener('pageshow', event => { if (event.persisted) { history = readHistory(storage); record(current.variantId); render(); } });
})();
